module.exports = __webpack_public_path__ + "img/cintes-personalitzades-2.aa9ecff5.jpg";